import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// These export the cardinal web "types" around Message bars and similar.
import { useThemeData } from '@msrceng/theme';
import { Tag } from './Tag';
/** Matches your theme's `MessageBarType.Success` styles */
export const SuccessTag = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { theme } = useThemeData();
    return (_jsx(Tag, Object.assign({}, rest, { background: theme.semanticColors.successBackground, color: theme.semanticColors.successIcon }, { children: children })));
};
/** Matches your theme's `MessageBarType.Warning` styles */
export const WarningTag = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { theme } = useThemeData();
    return (_jsx(Tag, Object.assign({}, rest, { background: theme.semanticColors.warningBackground, color: theme.semanticColors.warningIcon }, { children: children })));
};
/** Matches your theme's `MessageBarType.SevereWarning` styles */
export const SevereWarningTag = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { theme } = useThemeData();
    return (_jsx(Tag, Object.assign({}, rest, { background: theme.semanticColors.severeWarningBackground, color: theme.semanticColors.severeWarningIcon }, { children: children })));
};
/** Matches your theme's `MessageBarType.Blocked` styles */
export const BlockingTag = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { theme } = useThemeData();
    return (_jsx(Tag, Object.assign({}, rest, { background: theme.semanticColors.blockingBackground, color: theme.semanticColors.blockingIcon }, { children: children })));
};
/** Matches your theme's `MessageBarType.Info` styles */
export const InfoTag = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { theme } = useThemeData();
    return (_jsx(Tag, Object.assign({}, rest, { background: theme.semanticColors.infoBackground, color: theme.semanticColors.infoIcon }, { children: children })));
};
/** Matches your theme's `MessageBarType.Error` styles */
export const ErrorTag = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { theme } = useThemeData();
    return (_jsx(Tag, Object.assign({}, rest, { background: theme.semanticColors.errorBackground, color: theme.semanticColors.errorIcon }, { children: children })));
};
/** Matches your theme's `PrimaryButton` styles */
export const PrimaryTag = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { theme } = useThemeData();
    return (_jsx(Tag, Object.assign({}, rest, { background: theme.semanticColors.primaryButtonBackground, color: theme.semanticColors.primaryButtonText }, { children: children })));
};
